import React, { useState, useEffect } from 'react';

// Navigation Component for Styles Page - Matching Main Page
const StylesNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 sm:h-20 items-center">
          <div className="flex-shrink-0 flex items-center">
            <a href="/">
              <img 
                src="/main-logo.png" 
                alt="Banner Day Threads" 
                className="h-12 sm:h-16 opacity-90 hover:opacity-100 transition duration-300 drop-shadow-lg" 
              />
            </a>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-6 lg:space-x-8">
              <a href="/" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">Home</a>
              <a href="/styles" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">Our Styles</a>
              <a href="/about" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">About</a>
              <a href="/contact-us" className="bg-blue-600 text-white px-4 lg:px-6 py-2 rounded-full font-medium hover:bg-blue-700 transition duration-300 shadow-lg text-sm lg:text-base">Get Started</a>
            </div>
          </div>
          <div className="md:hidden flex items-center space-x-3">
            <a 
              href="/contact-us" 
              className="bg-blue-600 text-white px-4 py-2 rounded-full font-medium hover:bg-blue-700 transition duration-300 shadow-lg text-sm"
            >
              Get Started
            </a>
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
              className="text-black hover:text-gray-700 focus:outline-none drop-shadow-lg"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white bg-opacity-95 rounded-lg backdrop-blur-sm shadow-lg">
              <a href="/" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">Home</a>
              <a href="/styles" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">Our Styles</a>
              <a href="/about" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">About</a>
              <a href="/contact-us" className="block bg-blue-600 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-700 transition duration-300 text-center mx-3 mt-2">Get Started</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

// Hat data with all styles and their anchor IDs
const hatStyles = [
  {
    id: "perfect-game",
    name: "PERFECT GAME",
    description: [
      "Cod Span (97% POLY/ 3% SPAN)",
      "6 Panel / Curved Visor",
      "Stretch Fit",
      "S/M (56CM) & L/XL(58CM)",
      "Camo pattern is a sublimated pattern on white",
    ],
    hatImages: ["/hat1-1.png", "/hat1-2.png", "/hat1-3.png", "/hat1-4.png"],
    colorImages: [
      "/BEI.svg", "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg",
      "/GRY.svg", "/KGR.svg", "/NVY.svg", "/RED.svg", "/ROY.svg", "/WHT.svg",
    ],
  },
  {
    id: "air-flow",
    name: "AIR FLOW",
    description: [
      "POLY RIPSTOP (100% POLYESTER)",
      "6 PANEL/ SLIGHT CURVED VISOR",
      "SOLID ROPE",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE SNAPBACK ",
    ],
    hatImages: ["/hat2-1.png", "/hat2-2.png", "/hat2-3.png", "/hat2-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
      "/PNK.svg", "/PGY.svg", "/RED.svg", "/ROY.svg", "/STN.svg", "/WHT.svg",
    ],
  },
  {
    id: "laserluxe",
    name: "LASERLUXE",
    description: [
      "REFLECTOR /TERESA (100% POLYESTER)",
      "6 PANEL / SLIGHT CURVED VISOR",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE VELCRO",
    ],
    hatImages: ["/hat3-1.png", "/hat3-2.png", "/hat3-3.png", "/hat3-4.png"],
    colorImages: [
      "/BLK.svg", "/DKC.svg", "/DKM.svg", "/DPK.svg", "/GRN.svg", 
      "/LSB.svg", "/NVY.svg", "/ROY.svg", "/WHT.svg",
    ],
  },
  {
    id: "road-runner",
    name: "ROAD RUNNER",
    description: [
      "ELITE PERFORMANCE & MESH (100% POLYESTER)",
      "6 PANEL/ SLIGHT CURVED VISOR",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImages: ["/hat4-1.png", "/hat4-2.png", "/hat4-3.png", "/hat4-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
    ],
    meshColors: ["/BLK.svg", "/GRY.svg", "/IVY.svg", "/KHK.svg", "/NVY.svg", "/WHT.svg"],
  },
  {
    id: "high-point",
    name: "HIGH POINT",
    description: [
      "POLY RIPSTOP (100% POLYESTER)",
      "5 PANEL / SLIGHT CURVED VISOR",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImages: ["/hat5-1.png", "/hat5-2.png", "/hat5-3.png", "/hat5-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
      "/PNK.svg", "/PGY.svg", "/RED.svg", "/ROY.svg", "/STN.svg", "/WHT.svg",
    ],
  },
  {
    id: "night-shift",
    name: "NIGHT SHIFT",
    description: [
      "CVC HEATHER & MESH (100% POLYESTER)",
      "5 PANEL/ SLIGHT CURVED VISOR ",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImages: ["/hat6-1.png", "/hat6-2.png", "/hat6-3.png", "/hat6-4.png"],
    colorImages: [
      "/HCHR.svg", "/HLGY.svg", "/HNVY.svg",
    ],
    meshColors: [
      "/CHR.svg", "/BLK.svg", "/GRY.svg", "/IVY.svg", "/NVY.svg", "/WHT.svg",
    ],
  },
  {
    id: "ultralite",
    name: "ULTRALITE",
    description: [
      "COOLEVER (100% POLYESTER)",
      "6 PANEL / CURVED VISOR",
      "ADJUSTABLE VELCRO",
    ],
    hatImages: ["/hat7-1.png", "/hat7-2.png", "/hat7-3.png", "/hat7-4.png"],
    colorImages: [
      "/BLK.svg", "/CHR.svg", "/LGY.svg", "/LSB.svg", "/LTB.svg", "/MAR.svg",
      "/PRP.svg", "/RED.svg", "/STN.svg", "/WHT.svg",
    ],
  },
  {
    id: "caddy",
    name: "CADDY",
    description: [
      "POLY RIPSTOP (100% POLYESTER) ",
      "5 PANEL / CURVED VISOR",
      "SOLID ROPE",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImages: ["/hat8-1.png", "/hat8-2.png", "/hat8-3.png", "/hat8-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
      "/PNK.svg", "/PGY.svg", "/RED.svg", "/ROY.svg", "/STN.svg", "/WHT.svg",
    ],
  },
  {
    id: "crew",
    name: "CREW",
    description: [
      "WASHED 16'S TWILL (100% COTTON) ",
      "6 PANEL/ CURVED VISOR ",
      "ADJUSTABLE STRAPBACK",
    ],
    hatImages: ["/hat9-1.png", "/hat9-2.png", "/hat9-3.png", "/hat9-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
      "/PNK.svg", "/PGY.svg", "/RED.svg", "/ROY.svg", "/STN.svg", "/WHT.svg",
    ],
  },
  {
    id: "offroad",
    name: "OFFROAD",
    description: [
      "WASHED 16'S TWILL & SOFT MESH (50% COTTON / 50% POLYESTER)",
      "6 PANEL/ CURVED VISOR",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImages: ["/hat10-1.png", "/hat10-2.png", "/hat10-3.png", "/hat10-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
      "/PNK.svg", "/PGY.svg", "/RED.svg", "/ROY.svg", "/STN.svg", "/WHT.svg",
    ],
    meshColors: [
      "/CHR.svg", "/BLK.svg", "/GRY.svg", "/IVY.svg", "/NVY.svg", "/WHT.svg",
    ],
  },
  {
    id: "6-below",
    name: "6-BELOW",
    description: [
      "POLY RIPSTOP (100% POLYESTER)",
      "6 PANEL / FLAT BILL VISOR",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImages: ["/hat11-1.png", "/hat11-2.png", "/hat11-3.png", "/hat11-4.png"],
    colorImages: [
      "/BLK.svg", "/BLU.svg", "/BOR.svg", "/CRD.svg", "/DGR.svg", "/GRN.svg",
      "/GRY.svg", "/LNV.svg", "/LSB.svg", "/LTB.svg", "/NVY.svg", "/OLV.svg",
      "/PNK.svg", "/PGY.svg", "/RED.svg", "/ROY.svg", "/STN.svg", "/WHT.svg",
    ],
  },
  {
    id: "ultralite-visor",
    name: "ULTRALITE VISOR",
    description: [
      "COOLEVER (100% POLYESTER)",
      "STANDARD VISOR",
      "ADJUSTABLE VELCRO",
    ],
    hatImages: ["/hat12-1.png", "/hat12-2.png", "/hat12-3.png", "/hat12-4.png"],
    colorImages: [
      "/BLK.svg", "/CHR.svg", "/LGY.svg", "/LSB.svg", "/LTB.svg", "/MAR.svg",
      "/PRP.svg", "/RED.svg", "/STN.svg", "/WHT.svg",
    ],
  },
];

// Contact Section Component - Clean & Simple Version
const Contact = () => {
  useEffect(() => {
    // Load Typeform script
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      // Clean up script when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contact" className="py-20 bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Contact Us
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-700 mb-4">
            Interested in partnering with{' '}
            <span className="font-bold">Banner Day Threads?</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Please fill out the form and one of our team members will be in contact
            soon! We specialize in premium custom headwear with low minimums and quick turnarounds.
          </p>
        </div>

        {/* Simple Typeform Button Container */}
        <div className="text-center">
          <div 
            data-tf-live="01JVCQRKJF8MEZD1PD16JT7NQQ"
            aria-label="Contact form for Banner Day Threads custom headwear inquiries"
          />
        </div>
        
      </div>
    </section>
  );
};

// Individual Hat Style Component
const HatStyleCard = ({ hat, index }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 });
  const [isZoomed, setIsZoomed] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % hat.hatImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + hat.hatImages.length) % hat.hatImages.length);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setIsZoomed(false);
  };

  const nextImageModal = () => {
    setCurrentImageIndex((prev) => (prev + 1) % hat.hatImages.length);
    setIsZoomed(false);
  };

  const prevImageModal = () => {
    setCurrentImageIndex((prev) => (prev - 1 + hat.hatImages.length) % hat.hatImages.length);
    setIsZoomed(false);
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setMousePosition({ x, y });
    setIsZoomed(!isZoomed);
  };

  // Touch handlers for mobile swipe on main carousel
  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    // Prevent default scrolling behavior during swipe
    e.preventDefault();
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) nextImage();
    if (isRightSwipe) prevImage();
  };

  // Touch handlers for modal carousel
  const handleModalTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleModalTouchMove = (e) => {
    // Prevent default scrolling behavior during swipe
    e.preventDefault();
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleModalTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) nextImageModal();
    if (isRightSwipe) prevImageModal();
  };

  // Keyboard navigation for modal
  React.useEffect(() => {
    const handleKeyPress = (e) => {
      if (showModal) {
        switch (e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            prevImageModal();
            break;
          case 'ArrowRight':
            e.preventDefault();
            nextImageModal();
            break;
          case 'Escape':
            e.preventDefault();
            closeModal();
            break;
          default:
            break;
        }
      }
    };

    if (showModal) {
      document.addEventListener('keydown', handleKeyPress);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  return (
    <div className="mb-20" id={hat.id}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        
        {/* Hat Image Section */}
        <div className="relative">
          <div 
            className={`${index % 2 === 0 ? 'bg-gray-100' : 'bg-blue-50'} rounded-xl p-8 relative overflow-hidden cursor-grab active:cursor-grabbing touch-pan-x`}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ touchAction: 'pan-x' }}
          >
            {/* Navigation Arrows */}
            {hat.hatImages.length > 1 && (
              <>
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-300"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-300"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </>
            )}
            
            {/* Main Hat Image */}
            <div className="flex justify-center relative">
              {/* Left click area */}
              {hat.hatImages.length > 1 && (
                <div 
                  className="absolute left-0 top-0 w-1/3 h-full z-20 cursor-pointer"
                  onClick={prevImage}
                />
              )}
              
              {/* Right click area */}
              {hat.hatImages.length > 1 && (
                <div 
                  className="absolute right-0 top-0 w-1/3 h-full z-20 cursor-pointer"
                  onClick={nextImage}
                />
              )}
              
              <img 
                src={hat.hatImages[currentImageIndex]}
                alt={`${hat.name} view ${currentImageIndex + 1}`}
                className="max-w-full h-auto object-contain cursor-pointer transition-transform duration-300 hover:scale-105 relative z-10"
                onClick={openModal}
                style={{ maxHeight: '400px' }}
              />
            </div>

            {/* Image Indicators */}
            {hat.hatImages.length > 1 && (
              <div className="flex justify-center mt-4 space-x-2">
                {hat.hatImages.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => {
                      setCurrentImageIndex(idx);
                    }}
                    className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                      idx === currentImageIndex ? 'bg-orange-500' : 'bg-gray-400'
                    }`}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Modal for Zoomed Image */}
          {showModal && (
            <div 
              className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
              onClick={closeModal}
            >
              <div 
                className="relative max-w-4xl max-h-full w-full touch-pan-x"
                onTouchStart={handleModalTouchStart}
                onTouchMove={handleModalTouchMove}
                onTouchEnd={handleModalTouchEnd}
                style={{ touchAction: 'pan-x' }}
              >
                {/* Close Button */}
                <button
                  onClick={closeModal}
                  className="absolute top-4 right-4 z-50 bg-white hover:bg-gray-100 rounded-full p-2 shadow-lg transition-all duration-300"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                {/* Modal Image Container */}
                <div 
                  className="bg-white rounded-lg p-4 mx-auto relative overflow-hidden"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Modal Navigation Arrows - Inside the white container */}
                  {hat.hatImages.length > 1 && (
                    <>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          prevImageModal();
                        }}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 z-40 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-3 shadow-lg transition-all duration-300"
                      >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
                        </svg>
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          nextImageModal();
                        }}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 z-40 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-3 shadow-lg transition-all duration-300"
                      >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </>
                  )}

                  <div className="relative overflow-hidden rounded-lg">
                    <img 
                      src={hat.hatImages[currentImageIndex]}
                      alt={`${hat.name} view ${currentImageIndex + 1} - enlarged`}
                      className={`w-full h-auto object-contain transition-transform duration-300 ${
                        isZoomed ? 'cursor-zoom-out' : 'cursor-zoom-in'
                      }`}
                      style={{ 
                        maxHeight: '80vh',
                        transform: isZoomed ? `scale(2)` : 'scale(1)',
                        transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`
                      }}
                      onClick={handleImageClick}
                    />
                    
                    {/* Zoom Instructions */}
                    {!isZoomed && (
                      <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white text-xs px-3 py-2 rounded-lg">
                        Click to zoom
                      </div>
                    )}

                    {/* Zoom Reset Instructions - Fixed positioning */}
                    {isZoomed && (
                      <div className="absolute bottom-2 left-2 bg-black bg-opacity-70 text-white text-xs px-3 py-2 rounded-lg">
                        Click again to zoom out
                      </div>
                    )}
                  </div>
                  
                  {/* Modal Image Indicators */}
                  {hat.hatImages.length > 1 && (
                    <div className="flex justify-center mt-4 space-x-2">
                      {hat.hatImages.map((_, idx) => (
                        <button
                          key={idx}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentImageIndex(idx);
                            setIsZoomed(false);
                          }}
                          className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                            idx === currentImageIndex ? 'bg-orange-500' : 'bg-gray-400'
                          }`}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Hat Details Section */}
        <div className="space-y-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">{hat.name}</h2>
            {/* Quick description under the name */}
            <p className="text-sm text-gray-600 mb-4">
              {hat.name === "PERFECT GAME" && "A sleek stretch-fit cap built from performance poly-span fabric with a curved visor. Available in S/M and L/XL, it delivers comfort and flexibility, with camo options created through sublimated prints."}
              {hat.name === "AIR FLOW" && "Designed for breathability, this ripstop performance cap features laser-cut perforations, solid rope detail, and a curved visor. Adjustable snapback for a versatile fit."}
              {hat.name === "LASERLUXE" && "A modern, technical cap with polyester fabric and precision perforation. Lightweight comfort meets Velcro adjustability for all-day wear."}
              {hat.name === "ROAD RUNNER" && "Classic trucker styling with a performance edge. Built from polyester with mesh panels, a curved visor, and snapback closure for everyday wear."}
              {hat.name === "HIGH POINT" && "Performance ripstop cap with a 5-panel design and breathable perforations. Slightly curved visor and snapback closure keep it sporty and stylish."}
              {hat.name === "NIGHT SHIFT" && "Heathered crown meets mesh in this 5-panel snapback. A casual, everyday trucker with modern heather texture and classic adjustability."}
              {hat.name === "ULTRALITE" && "Feather-light polyester cap with a curved visor and Velcro closure. Built for performance, comfort, and active lifestyles."}
              {hat.name === "CADDY" && "Ripstop 5-panel with rope detail and a curved visor. A modern performance spin on a classic golf-inspired snapback."}
              {hat.name === "CREW" && "Soft, washed cotton twill with a timeless 6-panel fit. Curved visor and strapback closure make this your go-to everyday cap."}
              {hat.name === "OFFROAD" && "A washed cotton-poly blend with soft mesh back panels. This 6-panel trucker delivers broken-in comfort with snapback adjustability."}
              {hat.name === "6-BELOW" && "Performance ripstop cap with breathable perforations and a flat bill visor. A bold look paired with lightweight durability."}
              {hat.name === "ULTRALITE VISOR" && "Minimalist visor crafted from feather-light polyester with Velcro closure. Keeps it cool, comfortable, and performance-ready."}
            </p>
          </div>
          
          {/* Description */}
          <div className="space-y-1">
            <ul className="space-y-1">
              {hat.description.map((point, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span className="text-gray-700 font-medium text-xs uppercase">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Main Colors */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-900">Available Colors</h4>
            <div className="grid grid-cols-6 gap-3 max-w-md">
              {hat.colorImages.map((colorImg, idx) => (
                <div key={idx} className="w-16 h-16 rounded-lg border-2 border-gray-200 hover:border-blue-500 transition-colors duration-300 p-1 bg-white">
                  <img 
                    src={colorImg}
                    alt={`Color option ${idx + 1}`}
                    className="w-full h-full object-contain"
                    style={{ 
                      imageRendering: 'crisp-edges',
                      msInterpolationMode: 'nearest-neighbor'
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Mesh Colors (if available) */}
          {hat.meshColors && (
            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-2">
                <h4 className="text-lg font-semibold text-gray-900">Mesh Colors</h4>
              </div>
              <div className="grid grid-cols-6 gap-3 max-w-md">
                {hat.meshColors.map((colorImg, idx) => (
                  <div key={idx} className="w-16 h-16 rounded-lg border-2 border-gray-200 hover:border-blue-500 transition-colors duration-300 p-1 bg-white">
                    <img 
                      src={colorImg}
                      alt={`Mesh color option ${idx + 1}`}
                      className="w-full h-full object-contain"
                      style={{ 
                        imageRendering: 'crisp-edges',
                        msInterpolationMode: 'nearest-neighbor'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>

      {/* Divider */}
      {index < hatStyles.length - 1 && (
        <div className="border-b border-gray-300 mt-16"></div>
      )}
    </div>
  );
};

// Footer Section - Matching Main Page
const Footer = () => (
  <footer className="bg-gray-900 text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
        <div className="sm:col-span-2 lg:col-span-1">
          <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-4 sm:mb-6">
            Banner Day Threads
          </h3>
          <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
            We craft premium custom headwear that fully highlights your brand. Not ours.
          </p>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Products</h4>
          <ul className="space-y-1 sm:space-y-2">
            {['Snapbacks', 'Rope Hats', 'Trucker Hats', 'Bucket Hats', 'Visors'].map((item, index) => (
              <li key={index}>
                <span className="text-gray-400 text-sm sm:text-base">{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Company</h4>
          <ul className="space-y-1 sm:space-y-2">
            <li>
              <a href="/about" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                About
              </a>
            </li>
            <li>
              <a href="/contact-us" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
        {/* <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Legal</h4>
          <ul className="space-y-1 sm:space-y-2">
            <li>
              <a href="/terms" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="/privacy" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div> */}
      </div>
      <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center">
        <p className="text-gray-400 mb-4 md:mb-0 text-sm sm:text-base text-center md:text-left">
        © 2025 Banner Day Threads, LLC. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

// Main Styles Page Component
const StylesPage = () => {
  // Handle scrolling to specific hat section on page load
  React.useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      // Small delay to ensure page has loaded
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          // Calculate offset for sticky navigation (nav height + padding)
          const navHeight = 80; // Approximate nav height
          const additionalPadding = 40; // Extra padding for better visual spacing
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight - additionalPadding;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <StylesNavigation />
      
      {/* Header Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our{' '}
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Hat Styles
            </span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Explore our complete collection of premium custom headwear. Each style is crafted with quality materials and designed to showcase your brand.
          </p>
        </div>
      </section>

      {/* Hat Styles Gallery */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {hatStyles.map((hat, index) => (
            <HatStyleCard key={index} hat={hat} index={index} />
          ))}
        </div>
      </section>

      {/* Add Contact Section */}
      <Contact />

      <Footer />
    </div>
  );
};

export default StylesPage;